module.exports = __webpack_public_path__ + "img/kantseljarija-i-ofisnye-prinadlezhnosti.b3d65339.svg";